import React from 'react';
import { Box, Typography } from '@mui/material';
import { APP_VERSION } from '../../../../../config/version';

export const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: '#ffffff',
        borderTop: '1px solid #e0e0e0',
        padding: 2,
        textAlign: 'center',
      }}
    >
      <Typography
        variant="caption"
        sx={{
          color: '#666666',
          fontFamily: 'Poppins, sans-serif',
        }}
      >
        v{APP_VERSION} - Powered by CV Printing S.A.S
      </Typography>
    </Box>
  );
}; 